import { JSX } from 'react';

export enum ESettingsTypes {
  Site = 'site',
  Advanced = 'advanced',
  Courses = 'courses',
  Leaderboard = 'leaderboard',
  Integrations = 'integrations',
}

export enum ESettingsTypesLabels {
  Site = 'General',
  Advanced = 'Advanced',
  Courses = 'Courses',
  Leaderboard = 'Leaderboard',
  Integrations = 'Integrations',
}

export enum ESettingsAdvancedWidgetLabels {
  COOKIE_BANNER = 'Cookie banner',
  EMAIL_OPTIN = 'Marketing email opt-in',
  SESSION_METADATA = 'Session metadata',
  PUBLISH_LOCKING = 'Publish locking',
  PRODUCT_ID = 'Product ID (DMA)',
}

export type TSettingsAdvancedWidget = {
  label: string;
  content?: JSX.Element;
};

export interface ISiteDetailMetadata {
  name: string;
  description: string;
}

export interface ICalendarDetailMetadata {
  name: string;
  description: string;
}
